export const studioStats = [
  { value: 'Ready', label: 'Prepared for real client project uploads' },
  { value: 'UI/UX', label: 'Programming-first visual presentation' },
  { value: '100%', label: 'ATA Code House branding across every view' },
  { value: 'Motion', label: 'Smooth, coded, professional interface animation' },
];

export const servicePillars = [
  {
    code: 'APP',
    title: 'Mobile Product Development',
    description:
      'Shopping, delivery, community, and service apps designed with complete user journeys instead of surface-level mockups.',
    points: ['Real screen hierarchy', 'Cart, order, and account states', 'Launch-ready interaction logic'],
  },
  {
    code: 'WEB',
    title: 'Website and Dashboard Systems',
    description:
      'Company websites, admin tools, analytics consoles, and sales pages with strong presentation and practical structure.',
    points: ['Responsive page systems', 'Professional content architecture', 'Business-focused interface blocks'],
  },
  {
    code: 'BOT',
    title: 'Automation and Bot Flow',
    description:
      'Support bots and booking assistants that route user intent, collect structured data, and keep service teams informed.',
    points: ['Conversation mapping', 'Escalation logic', 'Fast operational UX'],
  },
  {
    code: 'BRAND',
    title: 'Branded UI UX Direction',
    description:
      'Every project carries ATA Code House visual identity and feels like a serious software product prepared for real presentation.',
    points: ['Branded components', 'Professional typography', 'Structured visual hierarchy'],
  },
];

export const homeHighlights = [
  {
    title: 'Safer interaction structure',
    text: 'Navigation, modal behavior, and content hierarchy are arranged to feel stable and predictable during client review.',
  },
  {
    title: 'Clean presentation confidence',
    text: 'Each section is framed to feel professional, reducing noise while keeping important service and product details visible.',
  },
  {
    title: 'Reliable demo experience',
    text: 'Interactive previews are surfaced in a way that helps viewers focus on the product flow instead of fighting the interface.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Requirement Framing',
    text: 'We define the business goal, feature depth, and presentation angle before touching layouts.',
  },
  {
    step: '02',
    title: 'UX Flow Mapping',
    text: 'User journeys, checkout states, dashboard sections, and action logic are organized like a real product.',
  },
  {
    step: '03',
    title: 'Branded UI Build',
    text: 'Components, interactions, typography, and data display are coded into a polished product showcase.',
  },
  {
    step: '04',
    title: 'Client-Ready Delivery',
    text: 'The final result is suitable for professional demo use, portfolio presentation, or sales conversation.',
  },
];

export const projectShowcase = [
  {
    id: 'shopping-app',
    category: 'Mobile App',
    title: 'Shopping App',
    label: 'Live shopping app demo with cart, payment, and order flow',
    brandLine: 'ATA Code House Shopping Demo',
    description:
      'A professional shopping app demo with premium storefront styling, quantity controls, branded live preview, payment selection, cart review, and order completion UI in one floating experience.',
    timeline: 'Product browsing, cart control, payment, and order confirmation',
    metrics: [
      { value: 'Cart', label: 'Quantity increase and decrease states' },
      { value: 'Pay', label: 'Payment and checkout UI included' },
      { value: 'Order', label: 'Completion state ready in preview' },
    ],
    features: ['Product feed', 'Skeleton product art', 'Cart summary', 'Payment selector', 'Order confirmation'],
    deliverables: [
      'Scrollable shopping feed with branded app shell',
      'Product cards using animated skeleton visuals',
      'Interactive cart with editable quantity states',
      'Payment, billing, and order confirmation interface',
    ],
    flow: ['Browse', 'Add to cart', 'Adjust quantity', 'Choose payment', 'Place order'],
  },
];
